import Detect from './Detect';

export default Detect
export { Detect as Base }